import { useTranslation } from "react-i18next";
import { css } from "../../../../../styled-system/css";
import { VStack } from "../../../../../styled-system/jsx";
import DialogueCard from "../../../../modules/onboarding/components/DialogueCard";
import { useNavigate, createFileRoute } from "@tanstack/react-router";
import SkipToDashboardLink from "../../../../modules/onboarding/components/SkipToDashboardLink";
import { setChannel } from "../../../../redux/reducers/channel";
import { useAppDispatch } from "../../../../redux/hooks";
import { apiClient } from "../../../../zodios/client";
import * as Sentry from "@sentry/react";
import { errorToast } from "../../../../utils/toasts";

const Channel = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["onboarding"]);

  const selectChannel = async (
    channel: "amazon" | "walmart",
    nextPath: "/onboarding/v2/connect" | "/onboarding/v2/sellertype",
    search?: { channel: string },
  ) => {
    dispatch(setChannel(channel));
    localStorage.channel = channel;

    // Persist channel to backend so it survives page refresh
    try {
      await apiClient.setOnboardingChannel({ channel: channel.toUpperCase() as "AMAZON" | "WALMART" });
    } catch (error) {
      Sentry.captureException(error);
      errorToast({ message: t(($) => $.onboarding["Something went wrong. Check your connection and try again."]) });
      return;
    }

    void navigate({ to: nextPath, search });
  };

  return (
    <VStack
      css={{
        alignItems: "flex-start",
        width: "100%",
        maxWidth: { base: "100%", lg: "66.666%" },
        marginX: "auto",
        paddingY: "xlarge",
        textAlign: "start",
      }}
      gap="large"
    >
      <VStack gap="xsmall" alignItems="flex-start" width="100%">
        <h2 className={css({ fontWeight: "600" })}>{t(($) => $.onboarding["Connect To Your Marketplaces"])}</h2>
        <p className={css({ fontSize: "xlarge" })}>
          {t(
            ($) =>
              $.onboarding[
                "Connect the channels you want to optimize. You will be able to add more after you onboard."
              ],
          )}
        </p>
        <h4 className={css({ fontWeight: "500" })}>{t(($) => $.onboarding["Select Your Channels"])}</h4>
      </VStack>

      <VStack gap="medium" width="100%">
        <DialogueCard
          title={t(($) => $.onboarding.Amazon)}
          justify="center"
          onPress={() => void selectChannel("amazon", "/onboarding/v2/connect", { channel: "amazon" })}
        />
        <DialogueCard
          title={t(($) => $.onboarding.Walmart)}
          justify="center"
          onPress={() => void selectChannel("walmart", "/onboarding/v2/sellertype")}
        />
        <SkipToDashboardLink />
      </VStack>
    </VStack>
  );
};

export const Route = createFileRoute("/_authenticated/onboarding/v2/channel")({
  component: Channel,
});
